"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _q = _interopRequireDefault(require("q"));

var _noAuthApiClient = _interopRequireDefault(require("hub-http/clients/noAuthApiClient"));

var _memoize = _interopRequireDefault(require("../core/utilities/memoize"));

var _merchandiseAdapter = _interopRequireDefault(require("../adapters/merchandiseAdapter"));

var MERCHANDISE_ENDPOINT = '/monetization-service/v2/merchandise';
var fetchMerchandise = (0, _memoize.default)(function (earlyRequestName) {
  var earlyRequest = window.quickFetch && window.quickFetch.getRequestStateByName(earlyRequestName);

  if (!earlyRequest) {
    return _noAuthApiClient.default.get(MERCHANDISE_ENDPOINT);
  }

  return new _q.default.Promise(function (resolve, reject) {
    earlyRequest.whenFinished(function (result) {
      resolve(result);
      window.quickFetch.removeEarlyRequest(earlyRequestName);
    });
    earlyRequest.onError(function (err) {
      window.quickFetch.removeEarlyRequest(earlyRequestName);
      return _noAuthApiClient.default.get(MERCHANDISE_ENDPOINT).then(resolve).catch(function () {
        return reject(err);
      });
    });
  });
});

var getMerchandise = function getMerchandise() {
  var earlyRequestName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return fetchMerchandise(earlyRequestName).then(_merchandiseAdapter.default);
};

var _default = getMerchandise;
exports.default = _default;
module.exports = exports.default;